"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceTokenByLink = void 0;
/**
 * The "replaceTokenByLink" method returns a string content with the provided tokens replaced by HTML Anchor tags.
 *
 * @param content The original string content containing the token to be replaced.
 * @param token The token pattern that will be replaced by the HTML Anchor tag.
 * @param link Object containing instructions to build the HTML Anchor tag.
 * @param linkContent The inner content of the HTML Anchor tag.
 * @returns
 */
function replaceTokenByLink(content, token, link, linkContent) {
    const href = `href="${link.href}"`;
    const title = `title="${link.title}"`;
    const download = link.download ? `download="${link.download}"` : '';
    const target = link.target ? `target="${link.target}"` : '';
    const trackingAttrs = `autotagging-flora="on" data-flora="button" data-flora-text="${linkContent}"`;
    return content.replace(token, `<a ${href} ${title} ${download} ${target} ${trackingAttrs}>${linkContent}</a>`);
}
exports.replaceTokenByLink = replaceTokenByLink;
